(ns core.authorization.mfa.model
  (:require [cloudpermit-commons.schemas.general :as general]
            [schema-tools.core :as st]
            [schema.core :as s]))


(def config-types [:mfa-config.type/duo-oidc])
(def common-fields [:mfa-config/display-name])
(def secret-fields #{:mfa-config/client-secret})
(def checkbox-fields [:mfa-config/enabled-by-default?
                      :mfa-config/users-can-disable?
                      :mfa-config/ignore-on-api-error?])

(s/defschema MFAConfigKeys
  (st/merge {:mfa-config/type                (apply s/enum config-types)
             :mfa-config/id                  general/NonBlankString
             :mfa-config/display-name        general/NonBlankString
             :mfa-config/users-can-disable?  s/Bool
             :mfa-config/enabled-by-default? s/Bool}
            (st/optional-keys {:db/id                           (s/cond-pre s/Int s/Str)
                               :mfa-config/client-id            general/NonBlankString
                               :mfa-config/client-secret        general/NonBlankString
                               :mfa-config/api-hostname         general/NonBlankString
                               :mfa-config/ignore-on-api-error? s/Bool})))


(def config-type->key-order
  {:mfa-config.type/duo-oidc (concat common-fields
                                     [:mfa-config/client-id
                                      :mfa-config/client-secret
                                      :mfa-config/api-hostname])})


(s/defschema DuoOIDCConfig
  (st/required-keys MFAConfigKeys (-> config-type->key-order :mfa-config.type/duo-oidc vec)))


(s/defschema DuoOIDCConfigEdit
  (st/optional-keys DuoOIDCConfig [:mfa-config/client-secret]))


(def is-duo-config? (comp (partial = :mfa-config.type/duo-oidc) :mfa-config/type))


(s/defschema MFAAnyConfig
  (s/conditional (every-pred is-duo-config? :db/id) DuoOIDCConfigEdit
                 is-duo-config? DuoOIDCConfig
                 :else MFAConfigKeys))
